import { render, staticRenderFns } from "./TemplateA.vue?vue&type=template&id=5649484e&scoped=true&"
import script from "./TemplateA.vue?vue&type=script&lang=js&"
export * from "./TemplateA.vue?vue&type=script&lang=js&"
import style0 from "./TemplateA.vue?vue&type=style&index=0&id=5649484e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5649484e",
  null
  
)

export default component.exports